// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iqlphxnbmvV1c7NxSBXUl","link":"bL2ewqtGtUqI8FhhHVJzs"};